module.exports = __webpack_public_path__ + "static/media/singleFamilyHouse-geotiller.2f4382e8.svg";